import {
  getOptions,
  getTransactionTableColumns,
  TableRow,
} from "@bitwarden/web-vault/app/components/tables/transaction-table/transaction-table";
import { ScenarioTransactionTableSubscription } from "./scenario-transaction-table.subscription";
import { GridOptions } from "ag-grid-enterprise";
import type { ColDef } from "ag-grid-enterprise";
import { inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { View as ViewEnum } from "@bitwarden/web-vault/app/models/enum/view.enum";

export class ScenarioTransactionTable extends ScenarioTransactionTableSubscription {
  options: GridOptions<TableRow>;
  dialog = inject(MatDialog);
  i18n = inject(I18nService);

  constructor() {
    super();

    this.options = {
      ...getOptions(this.dialog, ViewEnum.FUTURE),
      suppressContextMenu: true,
      columnDefs: this.getScenarioTransactionTableColumns(),
    };
  }

  private getScenarioTransactionTableColumns(): ColDef<TableRow>[] {
    const columns = getTransactionTableColumns();
    const amountCol = columns.find((c) => c.field === "amount");
    if (amountCol) {
      amountCol.width = 175;
    }
    return columns;
  }
}
